'use client';

import {useState} from 'react';
import './WhoWeAre.scss';

const TABS = [
  {
    label: 'On a mission',
    title: 'On a mission',
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='12' cy='12' r='9' />
        <circle cx='12' cy='12' r='4.5' />
        <path d='M12 3v2.5M21 12h-2.5M12 21v-2.5M3 12h2.5' />
      </svg>
    ),
    paragraphs: [
      'Security has become expensive, fragmented, and complex. We believe there is a better way.',
      'Cylerian unifies security, observability, and operations on one AI-native platform: one agent, one data plane, one console. Protecting an organization should no longer mean stitching together a dozen tools.'
    ]
  },
  {
    label: 'Built for every team',
    title: 'Built for every team',
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M12 3l9 5-9 5-9-5 9-5Z' />
        <path d='M3 13l9 5 9-5' />
      </svg>
    ),
    paragraphs: [
      'From MSPs and MSSPs protecting hundreds of clients to enterprises consolidating their stack, Cylerian gives every team everything it needs out of the box.',
      'And with open APIs and endless integration options, your existing investments keep working for you.'
    ]
  },
  {
    label: 'Your team in the loop',
    title: 'Your team in the loop',
    icon: (
      <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.7' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='8.5' cy='8' r='3' />
        <path d='M3 19c.7-2.9 2.9-4.7 5.5-4.7S13.3 16.1 14 19' />
        <circle cx='17' cy='9.5' r='2.4' />
        <path d='M14.8 19c.5-2.1 2-3.4 3.9-3.4 1 0 1.9.4 2.6 1' />
      </svg>
    ),
    paragraphs: [
      'AI does the heavy lifting: detecting, triaging, and remediating threats at machine speed. Your team keeps the judgment calls.',
      'Cylerian works alongside the people who run security, helping them respond faster without growing headcount.'
    ]
  }
];

const WhoWeAre = () => {
  const [active, setActive] = useState(0);
  const tab = TABS[active];

  return (
    <section className='who-we-are'>
      <div className='wwa-inner'>
        <p className='why-label'>Who we are</p>
        <h2 className='wwa-heading'>
          Who we are <span className='why-accent'>and what we do.</span>
        </h2>
        <div className='wwa-grid'>
          <div className='wwa-tabs' role='tablist' aria-label='Who we are'>
            {TABS.map((t, i) => (
              <button
                key={i}
                type='button'
                role='tab'
                aria-selected={active === i}
                className={`wwa-tab${active === i ? ' active' : ''}`}
                onClick={() => setActive(i)}
              >
                {t.label}
                <span className='wwa-tab-arrow' aria-hidden='true'>→</span>
              </button>
            ))}
          </div>
          <div className='wwa-panel' role='tabpanel'>
            <span className='wwa-icon'>{tab.icon}</span>
            <h3 className='wwa-title'>{tab.title}</h3>
            {tab.paragraphs.map((p, i) => (
              <p className='wwa-body' key={i}>{p}</p>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
